// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wSGK","rootNoMargin":"styles_rootNoMargin__3My9Z"};